import { useState } from "react";
import NetworkAPI from "../../../api/NetworkAPI";

const useUpdateHierarchy = () => {
	const [loading, setLoading] = useState(false);

	const updateHierarchy = async (data) => {
		setLoading(true);

		try {
			const result = await NetworkAPI.updateHierarchy(data);
			return { success: true, data: result };
		} catch (error) {
			console.error("Failed to update hierarchy:", error);
			return { success: false, error: error.message };
		} finally {
			setLoading(false);
		}
	};

	return {
		updateHierarchy,
		loading,
	};
};

export default useUpdateHierarchy;
